module.exports = __webpack_public_path__ + "img/action-record.554430e4.svg";